<template>
  <div class="input-password inline-button">
    <input
      :id="id"
      v-model="password"
      :disabled="disabled"
      :required="required"
      :class="{ 'invalid' : error }"
      :minlength="minlength"
      :type="isPasswordVisible ? 'text' : 'password'"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    >
    <button type="button" class="small subtle" :disabled="disabled" @click="toggle">
      {{ label }}
    </button>
  </div>
</template>
<script>

export default {
  props: {
    id: {
      type: String,
      default: 'password',
    },
    minlength: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    focus: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isPasswordVisible: false,
      password: '',
    };
  },

  computed: {
    label() {
      return this.isPasswordVisible ? this.$t('Hide') : this.$t('Show');
    },
  },

  watch: {
    password(value) {
      this.$emit('input', value);
    },
  },

  methods: {
    toggle() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
